export default {
  name: 'Files',
  icon: 'mdi-folder',
  label: 'Files',
  priority: 100,
  isRoot() {
    return true;
  },
};
